import type {ReactElement} from 'react';
import React, {useState} from 'react';
import {ToggleSwitch} from '@Components/toggle-switch-v2';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import '@Global/modal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

interface ReelTogglerProps {
  onReelToggle?: (newValue: boolean) => void;
  isToggled?: boolean;
  isDisabled?: boolean;
  disabledTooltipText?: string;
}

export function ReelToggler({onReelToggle = (value) => {}, isToggled = false, isDisabled = false, disabledTooltipText = ''}: ReelTogglerProps): ReactElement<any> | null {
  const [reelToggleState, setReelToggleState] = useState<boolean>(isToggled);

  const onToggle = (): void => {
    const newToggleValue = !reelToggleState;
    setReelToggleState(newToggleValue);
    onReelToggle(newToggleValue);
  };

  const getToggleSwitch = (): ReactElement<any> => {
    const toggleSwitch = <ToggleSwitch isDisabled={isDisabled} isChecked={reelToggleState} onChange={onToggle} />;

    if (isDisabled && disabledTooltipText !== '') {
      return (
        <OverlayTrigger
          trigger={['hover', 'focus', 'click']}
          overlay={
            <Tooltip className="_pointer-events-none" style={{position: 'fixed'}} id="reel-toggle-tooltip">
              {disabledTooltipText}
            </Tooltip>
          }
          delay={{show: 50, hide: 50}}
          placement="top"
          popperConfig={undefined}
          show={undefined}
          defaultShow={undefined}
          onHide={undefined}
          onToggle={undefined}
          target={undefined}
          flip={undefined}
          offset={undefined}
        >
          <span>{toggleSwitch}</span>
        </OverlayTrigger>
      );
    }

    return toggleSwitch;
  };

  return (
    <div className="flex-h-row flex-content-between">
      <div className="flex-vertical-center flex-center">
        <Icon icon="icon-insta-reels" className="spacing-m-r-2" size={IconSize.SIZE_ICON_16} type={IconType.NONE} shape={IconShape.NONE} />
        <Text val={window.i18next.t('pmwjs_post_video_as_reel')} size={TextSize.XSMALL} />
      </div>
      {getToggleSwitch()}
    </div>
  );
}
